import { render, staticRenderFns } from "./comDtoBasic2.vue?vue&type=template&id=b1112806&scoped=true&"
import script from "./comDtoBasic2.vue?vue&type=script&lang=js&"
export * from "./comDtoBasic2.vue?vue&type=script&lang=js&"
import style0 from "./comDtoBasic2.vue?vue&type=style&index=0&id=b1112806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1112806",
  null
  
)

export default component.exports